interface Coordinates {
  lat: number;
  lng: number;
  title: string;
}

const initMap = () => {
  const maps = document.querySelectorAll<HTMLDivElement>('.map__embed');
  maps.forEach((el) => {
    try {
      const dataProps = el.getAttribute('data-props');
      if (!dataProps) return;

      const data = JSON.parse(atob(dataProps)) as Coordinates[];
      const map = new google.maps.Map(el, {
        mapTypeControlOptions: {
          mapTypeIds: [],
        },
      });
      const bounds = new google.maps.LatLngBounds();
      data.forEach((d) => {
        const coordinates = {
          lat: d.lat,
          lng: d.lng,
        };
        bounds.extend(coordinates);
        new google.maps.Marker({
          map,
          position: coordinates,
          title: d.title,
        });
      });
      if (data.length > 1) {
        map.fitBounds(bounds);
      } else {
        map.setCenter(bounds.getCenter());
        map.setZoom(11);
      }
    } catch (_e) {
      return undefined;
    }
  });
};

window.initMap = initMap;
